import React from 'react'
import { FooterLink, FooterPage ,FooterIcons } from './Style'

export default function Footer() {
    return (
        <FooterPage>
            <h6>Educate</h6>
            <p>
                Lorem ipsum dolor sit amet, conse ctetur adi pisicin g elit.
                Doloribus repel lendus, pariatur qui provident repel lendus!
            </p>
            <FooterLink>
                <a>Home</a>
                <a>About</a>
                <a>Courses</a>
                <a>Contact</a>
            </FooterLink>
            <FooterIcons>
                <span> <i className="fab fa-facebook-f"></i> </span>
                <span> <i className="fab fa-twitter"></i> </span>
                <span> <i className="fab fa-linkedin-in"></i> </span>
                <span> <i className="fab fa-youtube"></i>  </span>
            </FooterIcons>
        </FooterPage>
    )
}
